import { makeStyles } from 'hooks';

export default makeStyles(theme => ({
  container: {
    outline: 'none'
  },
  onfiles: {
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: theme.palette.common.white,
      zIndex: 11,
      opacity: 0.3,
      border: `dotted 3px ${theme.palette.common.black}`,
      pointerEvents: 'none'
    },
    '&:after': {
      content: "'Add File(s)'",
      position: 'absolute',
      top: '50%',
      left: '50%',
      fontSize: 30,
      marginLeft: -70,
      marginTop: -30,
      pointerEvents: 'none',
      zIndex: 12
    }
  },
  imageContainer: {
    width: '100%',
    paddingBottom: '56.25%',
    position: 'relative'
  },
  imageContainerInner: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary['100']
  },
  downloadIcon: {
    position: 'absolute',
    bottom: 0,
    right: 0
  },
  fallback: {
    height: '80%',
    width: '80%',
    color: theme.palette.grey[700]
  },
  fileImage: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  progressOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.text.disabled,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  errorMessage: {
    marginBottom: theme.spacing(1)
  }
}));